import React from "react";

interface Props {
  className?: string;
}

export default function ShepherdLogo({ className = "" }: Props) {
  return (
    <div className={`flex items-center gap-4 ${className}`.trim()}>
      <svg width="72" height="72" viewBox="0 0 72 72" fill="none" aria-hidden="true">
        <defs>
          <linearGradient id="shep-silver" x1="14" y1="12" x2="57" y2="58" gradientUnits="userSpaceOnUse">
            <stop stopColor="#F8FBFF" />
            <stop offset="0.28" stopColor="#C8D2DE" />
            <stop offset="0.58" stopColor="#8F9BAC" />
            <stop offset="1" stopColor="#EEF3F9" />
          </linearGradient>
          <linearGradient id="shep-blue" x1="16" y1="10" x2="56" y2="54" gradientUnits="userSpaceOnUse">
            <stop stopColor="#45D4FF" />
            <stop offset="0.42" stopColor="#2B89D8" />
            <stop offset="1" stopColor="#5D56B7" />
          </linearGradient>
          <filter id="shep-shadow" x="6" y="8" width="60" height="60" filterUnits="userSpaceOnUse">
            <feDropShadow dx="0" dy="7" stdDeviation="4" floodColor="#8393AE" floodOpacity="0.32" />
          </filter>
        </defs>
        <g filter="url(#shep-shadow)">
          <path
            d="M37.4 11.6C46.8 11.6 54.4 18.7 54.4 27.2C54.4 31.7 52.2 35.9 48.4 38.9C45.8 41 42.7 42.4 40.3 44.5C37.1 47.3 35.3 50.9 33.6 54.4C27.1 53.3 22.2 48 22.2 41.7C22.2 37.5 24.3 33.6 27.7 30.8C30 28.9 32.7 27.6 35.2 25.9C39.9 22.7 42.8 18.2 45 13.3C42.7 12.2 40.1 11.6 37.4 11.6Z"
            fill="url(#shep-silver)"
          />
          <path
            d="M28.4 15.7C34 15.7 38.5 18.9 40.7 23.6C33.3 24.7 26.9 28.4 23 33.8C19.9 38.2 18.3 43.6 17.4 48.8C12.7 46.2 9.6 41.4 9.6 35.9C9.6 24.8 18 15.7 28.4 15.7Z"
            fill="url(#shep-blue)"
          />
          <path
            d="M46.8 18.8C50.8 22.3 53.4 27.5 53.4 33.2C53.4 43.8 44.4 52.5 33.3 52.5C31.9 52.5 30.6 52.4 29.3 52.1C36.1 50.2 41.5 45.5 44.8 39.5C47.6 34.3 48.5 28.5 48.9 22.9C48.2 21.5 47.5 20.1 46.8 18.8Z"
            fill="url(#shep-blue)"
          />
          <path
            d="M17.6 20.9C22 14.9 29.2 11 37.3 11C39.2 11 41 11.2 42.7 11.6C35.8 14 30.7 19.2 27.4 25.3C24.8 30.3 23.6 35.8 23 41.4C20.8 38.5 19.4 35.2 19 31.5C18.6 27.7 18.2 24.2 17.6 20.9Z"
            fill="white"
            fillOpacity="0.84"
          />
        </g>
      </svg>

      <div className="leading-none">
        <div className="text-[1.95rem] font-semibold tracking-tight text-[#17343a]">SHEPHERD</div>
        <div className="-mt-1 text-[1.35rem] font-medium tracking-[0.02em] text-[#83663d]">&amp; ASSOCIATES</div>
      </div>
    </div>
  );
}
